import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_405: DocMigration = {
  maxSchemaVersion: "0.0.405",
  description: "Remove invalid sheet geometry categories and repair missing sort index fields",
  apply(json: any) {
    if (json.viewTemplates) {
      for (const viewTemplateId in json.viewTemplates) {
        const viewTemplate = json.viewTemplates[viewTemplateId];
        viewTemplate.categories = viewTemplate.categories.filter(
          (x) =>
            x !== "ANNOTATION" &&
            x !== "PERIMS_WALL_WITH_OPENINGS" &&
            x !== "CEILING_HEIGHT_ANNOTATION" &&
            x !== "FOUNDATION_SOLID" &&
            x !== "ANNOT_LINEWORK_OFFSET_LINE",
        );
      }
    }

    const repairSortIndicesOnTable = (table: Record<string, any>) => {
      const parentIds = new Set(Object.values(table).map((x) => x.parentId));

      for (const parentId of parentIds) {
        Object.values(table)
          .filter((x) => x.parentId === parentId)
          .sort((a: any, b: any) => a.sortIndex - b.sortIndex)
          .forEach((entity: any, index: number) => {
            entity.sortIndex = index;
          });
      }
    };

    if (json.openings) {
      repairSortIndicesOnTable(json.openings);
    }

    if (json.rooms) {
      repairSortIndicesOnTable(json.rooms);
    }

    if (json.optionSets) {
      for (const optionSetId in json.optionSets) {
        const optionSet = json.optionSets[optionSetId];
        if (optionSet.options) {
          Object.values(optionSet.options as Record<string, any>)
            .sort((a: any, b: any) => a.sortIndex - b.sortIndex)
            .forEach((entity: any, index: number) => {
              entity.sortIndex = index;
              if (entity.parentId === undefined) {
                entity.parentId = optionSetId;
              }
            });
        }
      }
    }

    return json;
  },
};

export default migration_0_0_405;
